//SOLID COLORS//
export const BLACK_212121 = "#212121";
export const BLUE_004C7C = "#004C7C";
export const BLUE_025BB7 = "#025BB7";
export const GRAY_F8F8F8 = "#F8F8F8";
export const GRAY_838383 = "#838383";
export const GRAY_565656 = "#565656";
export const GRAY_E0E0E0 = "#E0E0E0";
export const GRAY_F2F2F2 = "#F2F2F2";
export const GRAY_F2F4F7 = "#F2F4F7";
export const GRAY_CACACA = "#CACACA";
export const GREEN_70B412 = "#70B412";
export const RED_DB0000 = "#DB0000";
export const WHITE_FFFFFF = "#FFFFFF";

//GRADIENT COLORS//
export const GRADIENT_PRIMARY =
  "linear-gradient(273.79deg, #025BB7 0%, #1894DF 100%)";
